export const SYSTEM_USERNAME = 'system';
export const API_KEY_SUFFIX = '_api_key';
export const EVERYONE_USERGROUP = 'Everyone';
export const AGENTS_USERGROUP = 'Agents';
export const EARLY_ACCESS_AGENTS = ['aq', 'tome'];

// Tab indexes for sorting
export const DATASOURCES_PARENT_TAB_INDEX = 0;
export const USER_MANAGEMENT_TAB_INDEX = 1;
export const SYSTEM_ACTIVITY_TAB_INDEX = 2;
export const CONFIGURATION_TAB_INDEX = 3;

// Datasource tab child tab indexes
export const DATASOURCES_TAB_INDEX = 0;
export const AGENTS_TAB_INDEX = 1;

// User management tab child tab indexes
export const USERS_TAB_INDEX = 0;
export const GROUPS_TAB_INDEX = 1;
export const CAPABILITIES_TAB_INDEX = 2;
export const ACCESS_KEYS_TAB_INDEX = 3;

// System activity tab child tab indexes
export const SCHEDULES_TAB_INDEX = 0;
export const JOBS_TAB_INDEX = 1;
export const REQUESTS_TAB_INDEX = 2;
export const EXPORTS_TAB_INDEX = 3;
export const USAGE_TAB_INDEX = 4;
export const SUBSCRIPTIONS_TAB_INDEX = 5;

export const SCHEDULABLE_TABLE_CANCELLATION_GROUP = 'schedulableAdminTable';
export const SCHEDULABLE_CHARTS_CANCELLATION_GROUP = 'schedulableAdminChart';

/**
 * Needs to be high enough to get all on busy servers, but not so high it causes OOM or frontend performance. 10k is a
 * good balance that has been tested.
 */
export const ADMIN_LIMIT = 10000;

// Tab IDs
export const USERS_TAB_ID = 'usersTab';
export const GROUPS_TAB_ID = 'groupsTab';
export const CAPABILITIES_TAB_ID = 'capabilitiesTab';
export const ACCESS_KEYS_TAB_ID = 'accessKeyTab';
export const REQUESTS_TAB_ID = 'requestsTab';
export const SUBSCRIPTIONS_TAB_ID = 'subscriptionsTab';
export const JOBS_TAB_ID = 'jobsTab';
export const DATASOURCES_TAB_ID = 'datasourcesTab';
export const AGENTS_TAB_ID = 'agentsTab';
export const SCHEDULES_TAB_ID = 'schedulesTab';
export const USAGE_TAB_ID = 'usageTab';
export const EXPORTS_TAB_ID = 'exportsTab';
export const CONFIGURATION_TAB_ID = 'configurationTab';
export const SYSTEM_ACTIVITY_TAB_ID = 'systemActivityTab';
export const USER_MANAGEMENT_TAB_ID = 'userManagementTab';
export const DATASOURCES_TAB_PARENT_ID = 'datasourceAdministrationTab';

// Route paths for administration tabs - maps tab IDs to URL path segments
const ADMINISTRATION_ROUTES_AND_TITLES = new Map<string, { route: string; title: string }>([
  [USERS_TAB_ID, { route: 'users', title: 'Users' }],
  [GROUPS_TAB_ID, { route: 'groups', title: 'Groups' }],
  [CAPABILITIES_TAB_ID, { route: 'capabilities', title: 'Capabilities' }],
  [ACCESS_KEYS_TAB_ID, { route: 'access-keys', title: 'Access Keys' }],
  [REQUESTS_TAB_ID, { route: 'requests', title: 'Requests' }],
  [SUBSCRIPTIONS_TAB_ID, { route: 'subscriptions', title: 'Subscriptions' }],
  [JOBS_TAB_ID, { route: 'jobs', title: 'Jobs' }],
  [DATASOURCES_TAB_ID, { route: 'datasources', title: 'Datasources' }],
  [AGENTS_TAB_ID, { route: 'agents', title: 'Agents' }],
  [SCHEDULES_TAB_ID, { route: 'schedules', title: 'Schedules' }],
  [USAGE_TAB_ID, { route: 'usage', title: 'Usage' }],
  [EXPORTS_TAB_ID, { route: 'exports', title: 'Exports' }],
  [CONFIGURATION_TAB_ID, { route: 'configuration', title: 'Configuration' }],
]);

export const ADMINISTRATION_ROUTES = new Map<string, string>(
  Array.from(ADMINISTRATION_ROUTES_AND_TITLES).map(([id, { route }]) => [id, route]),
);

// Reverse mapping: route path to tab ID
export const ROUTE_TO_TAB_ID = new Map<string, string>(
  Array.from(ADMINISTRATION_ROUTES).map(([id, route]) => [route, id]),
);

export const ROUTE_TO_TITLE = new Map<string, string>(
  Array.from(ADMINISTRATION_ROUTES_AND_TITLES).map(([, { route, title }]) => [route, title]),
);

export const ADMINISTRATION_DEFAULT_ROUTE = ADMINISTRATION_ROUTES.get(DATASOURCES_TAB_ID);
export const ADMINISTRATION_ROUTE_PATHS = Array.from(ADMINISTRATION_ROUTES.values());
